module.exports = __webpack_public_path__ + "img/EgyptTechSlinger2_ua.ffdba820.webp";